import React from 'react'
import { Block } from 'gerami'
import { FaClock, FaLocationArrow } from 'react-icons/fa'

import './schedule-card.scss'
import Anchor from '../../../shared/components/anchor/anchor'

type ScheduleCardProps = {
  slug: string
  title: string
  happensOn: string
  location: string
  excerpt?: string | null
}

const ScheduleCard: React.FC<ScheduleCardProps> = ({
  slug,
  title,
  happensOn,
  location,
  excerpt
}) => {
  return (
    <Anchor to={slug} className="schedule-card">
      <Block className="schedule-card-block">
        <h5>
          <div>{title}</div>
          <div className="subtitle font-M padding-top-normal">
            <small className="inline-block padding-right-normal">
              <small>
                <FaClock />
              </small>
            </small>
            {happensOn}

            <br />

            <small className="inline-block padding-right-normal">
              <small>
                <FaLocationArrow />
              </small>
            </small>
            {location}
          </div>
        </h5>
        <div className="subtitle padding-bottom-big">{excerpt}</div>
      </Block>
    </Anchor>
  )
}

export default ScheduleCard
